/**
 * Our Products Slider
 *
 * @param {string} slider
 * @param {Object} options
 * @returns {void}
 */
const ourProductsSlider = (slider, options) => {
    const defaultOptions = {
        items: 3,
        nav: true,
        dots: false,
        loop: false,
        navText: [
            '<span class="owl-arrow owl-arrow--prev"><i class="icon-owl-arrow-prev" aria-hidden="true"></i></span>',
            '<span class="owl-arrow owl-arrow--next"><i class="icon-owl-arrow-next" aria-hidden="true"></i></span>',
        ],
    };

    const $slider = $(slider);

    options = $.extend({}, defaultOptions, options);

    if ($slider.length) {
        $slider.owlCarousel(options);
    }
};

export default ourProductsSlider;
